// import { Swiper, SwiperSlide } from "swiper/react";
// import SwiperCore, { Autoplay, Pagination } from "swiper";
// import brandImg_1 from 'assets/images/partners/partner1.jpg'
// import brandImg_2 from 'assets/images/partners/partner2.jpg'
// import brandImg_3 from 'assets/images/partners/partner3.jpg'
// import brandImg_4 from 'assets/images/partners/partner4.jpg'
// import brandImg_5 from 'assets/images/partners/partner5.jpg'
// import brandImg_6 from 'assets/images/partners/partner6.jpg'
// import brandImg_7 from 'assets/images/partners/partner7.jpg'
// import brandImg_8 from 'assets/images/partners/partner8.jpg'
// import brandImg_9 from 'assets/images/partners/partner9.jpg'
// import brandImg_10 from 'assets/images/partners/partner10.jpg'
// import brandImg_11 from 'assets/images/partners/partner11.jpg'
import brandImg_1 from 'assets/images/partners/avax-logo.png'
import brandImg_2 from 'assets/images/partners/Binance-logo.png'
import brandImg_3 from 'assets/images/partners/songbird-logo.png'
import brandImg_4 from 'assets/images/partners/polygon-logo.png'
// SwiperCore.use([Autoplay, Pagination]);

const Partners = () => {
    // let brands = [
    //     { img: brandImg_1, link: 'https://nyweekly.com/business/nft-community-mutant-mingos-to-give-away-digital-lands-to-its-members/' },
    //     { img: brandImg_3, link: ' https://www.wicz.com/story/45391426/how-mutant-mingos-aims-to-make-its-dao-metaverse-land-pioneers' },
    //     { img: brandImg_4, link: 'https://thechicagojournal.com/emerging-collection-mutant-mingos-makes-waves-in-the-nft-space/' },
    //     { img: brandImg_6, link: 'https://marketdaily.com/?p=776' },
    //     { img: brandImg_7, link: 'https://usreporter.com/mutant-mingos-become-the-latest-nft-project-to-build-on-the-upcoming-metaverse/' },
    //     { img: brandImg_8, link: 'https://lawire.com/mutant-mingos-project-gives-holders-a-piece-of-a-fractionalized-plot-of-digital-real-estate-in-metaverse-with-each-nft/' },
    //     { img: brandImg_9, link: ' https://www.wboc.com/story/45391426/how-mutant-mingos-aims-to-make-its-dao-metaverse-land-pioneers' },
    //     { img: brandImg_10, link: 'https://www.wrde.com/story/45391426/how-mutant-mingos-aims-to-make-its-dao-metaverse-land-pioneers' },
    //     { img: brandImg_11, link: 'https://usinsider.com/the-mutant-mingos-nft-community-to-begin-its-public-minting-on-december-13-2021/' },
    //     { img: brandImg_5, link: 'https://nywire.com/upcoming-nft-project-mutant-mingos-set-to-dominate-the-digital-landscape/' },
    //     { img: brandImg_2, link: 'https://ceoweekly.com/how-mutant-mingos-aims-to-make-its-dao-metaverse-land-pioneers/' },
    // ];
    return (
        <section id="partners">
            <div className="sec-heading-wrapper">
                <h2 className="sec-heading" data-aos="zoom-out">Powered By</h2>
            </div>
            <div className="container">
                <div className="row partner-row">
                    <div className="partner-box avax">
                        <img src={brandImg_1} alt="" />
                    </div>
                    <div className="partner-box binance">
                        <img src={brandImg_2} alt="" />
                    </div>
                    <div className="partner-box song-bird">
                        <img src={brandImg_3} alt="" />
                    </div>
                    <div className="partner-box poly-gon">
                        <img src={brandImg_4} alt="" />
                    </div>
                </div>
            </div>
            {/* <Swiper
                autoplay={{ disableOnInteraction: false, delay: 1500 }}
                className="nft-slide-container"
                speed={500}
                initialSlide={0}
                pagination={{ clickable: true }}
                spaceBetween={75}
                centerInsufficientSlides
                slidesPerView={3}
                centeredSlides
                loop={true}
                grabCursor={false}
                breakpoints={{
                    190: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    992: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                    },
                    1500: {
                        slidesPerView: 4,
                    },
                    1800: {
                        slidesPerView: 5,
                    },
                    2200: {
                        slidesPerView: 5,
                    },
                    2800: {
                        slidesPerView: 6,
                    },
                }}
            >
                {brands.map((imgItem, index) => (
                    <SwiperSlide key={index} className="nft-slide">
                        <a className="article-link" href={imgItem.link} target="_blank" rel="noopener noreferrer">
                            <img className="nft-art-img" src={imgItem.img} alt="Mutant-Mingos" />
                        </a>
                    </SwiperSlide>
                ))}
            </Swiper> */}
        </section>
    )
}

export default Partners
